module.exports = __webpack_public_path__ + "img/logo.93193bb9.svg";